import useUploadProfileImageMutation from "./useUploadProfileImageMutation ";

interface UseFileUploadOptions {
  onSuccess?: (url: string) => void;
  onError?: () => void;
}

const useFileUpload = ({ onSuccess, onError }: UseFileUploadOptions) => {
  const { mutate: uploadProfileImageMutation, isPending } =
    useUploadProfileImageMutation({
      onError: () => {
        onError?.();
      },
      onSuccess: (response) => {
        onSuccess?.(response.url);
      },
    });

  const handleFileSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (file?.type && !validTypes.includes(file.type)) {
      alert("Invalid file type. Only MP4 and GIF files are allowed.");
      return;
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        uploadProfileImageMutation({
          file: reader.result as string,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  return {
    handleFileSelection,
    isPending,
  };
};

export default useFileUpload;
